import { render, staticRenderFns } from "./MultistepDomainRegistration.vue?vue&type=template&id=4d1ae5c8&"
import script from "./MultistepDomainRegistration.vue?vue&type=script&lang=js&"
export * from "./MultistepDomainRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports